module.exports = __webpack_public_path__ + "static/media/p1_img3.8a705802.png";